// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__31tNF","resendInfoText":"OnGoingPaymentBox_resendInfoText__3v9di"};